import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { element } from 'protractor';
import { DialogData } from 'src/app/common/delete-alert/delete-alert.component';
import { DataService } from 'src/app/service/data.service';

@Component({
  selector: 'app-select-serial-invoice',
  templateUrl: './select-serial-invoice.component.html',
  styleUrls: ['./select-serial-invoice.component.scss']
})
export class SelectSerialInvoiceComponent implements OnInit {
  searchitem = '';
  responseData: any;
  loadingTrue = false;
  GodwonTrue = false;
  searchTimeout: any;
  ic = '';
  item = {
    ina: '',
    ic: '',
    itemdisplayname: '',
    serialnumbers: [],
    reffield2: [],
    reffield3: [],
    reffield4: [],
    reffield5: [],
    reffield6: [],
    reffield7: [],
    reffield8: [],
    reffield9: [],
    reffield10: [],
  };
  itemData = {
    serialsetups: {
      reffield2: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield3: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield4: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield5: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield6: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield7: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield8: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield9: {
        required: '',
        caption: '',
        repeatable: ''
      },
      reffield10: {
        required: '',
        caption: '',
        repeatable: ''
      }
    },
    serialstocks: {
      godowncodes: [],
      godownnames: [],
      serialnumbers: [],
      reffield2: [],
      reffield3: [],
      reffield4: [],
      reffield5: [],
      reffield6: [],
      reffield7: [],
      reffield8: [],
      reffield9: [],
      reffield10: [],
    },
    totalstocks: '',
    salerate: '',
    p1: '',
    p2: '',
    p3: '',
    p4: '',
    p5: '',
    p6: ''
  };
  selectedSerialNo = [];
  xselectedserials = [];
  godowncodes = [];
  godownnames = [];
  ina = '';
  qty = '';
  basedonname = '';
  entry = {
    ic: '',
    entryupdatemode: '',
    entryname: '',
    entryno: '',
    entrybranchcode: '',
    entryfinyearcode: '',
    godowncode: '',
  }
  selectedgodown = [];
  @ViewChild('selectInput', { static: false }) selectInput: ElementRef;
  constructor(
    public dialogRef: MatDialogRef<SelectSerialInvoiceComponent>,
    @Inject(MAT_DIALOG_DATA) public xdata: DialogData,
    public data: DataService,
  ) {
    this.responseData = this.xdata;
    this.ic = this.responseData.ic;
    this.xselectedserials = this.responseData.serialnumbers;
    this.ina = this.responseData.ina;
    this.qty = this.responseData.qty;
    this.godowncodes = this.responseData.godowncodes;
    this.godownnames = this.responseData.godownnames;
    this.basedonname = this.responseData.basedonname;
    if (this.responseData.godowncode) {
      this.entry.godowncode = this.responseData.godowncode;
    }

    this.entry.ic = this.responseData.ic;
    if (this.responseData.entryupdatemode === 'YES') {
      this.entry.entryupdatemode = this.responseData.entryupdatemode;
      this.entry.entryname = this.responseData.entryname;
      this.entry.entryno = this.responseData.entryno;
      this.entry.entrybranchcode = this.responseData.entrybranchcode;
      this.entry.entryfinyearcode = this.responseData.entryfinyearcode;
    }
  }

  ngOnInit() {
    setTimeout(() => {
      this.onFocus();
    }, 500);
    this.item = this.responseData.item;
    this.getData();
    if (this.data.authorizationResponse.edition_features.multiwarehouses === 'YES' && this.data.authorizationkey.branchwisesetup.multigodownrequired === 'YES') {
      this.GodwonTrue = true;
    }
  }

  clearItemData() {
    this.itemData = {
      serialsetups: {
        reffield2: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield3: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield4: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield5: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield6: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield7: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield8: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield9: {
          required: '',
          caption: '',
          repeatable: ''
        },
        reffield10: {
          required: '',
          caption: '',
          repeatable: ''
        }
      },
      serialstocks: {
        godowncodes: [],
        godownnames: [],
        serialnumbers: [],
        reffield2: [],
        reffield3: [],
        reffield4: [],
        reffield5: [],
        reffield6: [],
        reffield7: [],
        reffield8: [],
        reffield9: [],
        reffield10: [],
      },
      totalstocks: '',
      salerate: '',
      p1: '',
      p2: '',
      p3: '',
      p4: '',
      p5: '',
      p6: ''
    };
  }

  getData() {
    this.loadingTrue = true;
    this.data.postData('item/serialdetails', this.entry).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.itemData = this.responseData.data;
        this.xselectedserials.forEach(element => {
          const index = this.itemData.serialstocks.serialnumbers.indexOf(element);
          this.serialAdd(element, index);
        });
      } else {
        this.clearItemData();
      }
      this.loadingTrue = false;
    }, (error) => { });
  }

  searchItem() {
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.getData();
    }, 500);
  }

  serialAdd(stock, sindex) {
    const i = this.selectedSerialNo.map(e => e.serialnumber).indexOf(stock);
    if (i === -1) {
      const obj = {
        serialnumber: stock,
        index: sindex,
        godown: this.itemData.serialstocks.godowncodes[sindex]
      };
      this.selectedSerialNo.push(obj);
    } else {
      this.selectedSerialNo.splice(i, 1);
    }

    // const index = this.selectedgodown.map(e => e.serialgodowncodes).indexOf(stock);
    // if (index === -1) {
    //   const obj = {
    //     serialgodowncodes: stock.godowncode,
    //     index: sindex
    //   };
    //   this.selectedgodown.push(obj);
    // }
  }

  goNext(): void {
    if (this.basedonname === 'Order' && parseFloat(this.qty) < this.selectedSerialNo.length) {
      this.data.openAlertFalse("Please Select Serial No Within Given Qty");
    } else {
      const selected = [];
      const selected1 = [];
      this.selectedSerialNo.forEach(element => {
        selected.push(element.serialnumber);
        selected1.push(element.godown);
      });
      this.dialogRef.close({
        selectedserial: selected,
        //  selectedserialgodowncodes: this.itemData.serialstocks.godowncodes,
        selectedserialgodowncodes: selected1,
        salerate: this.itemData.salerate,
        p1: this.itemData.p1,
        p2: this.itemData.p2,
        p3: this.itemData.p3,
        p4: this.itemData.p4,
        p5: this.itemData.p5,
        p6: this.itemData.p6,
        selected: true
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  removeSerialNo(el): void {
    this.selectedSerialNo.splice(el, 1);
  }

  checkSelected(val) {
    return this.selectedSerialNo.map(e => e.serialnumber).indexOf(val) === -1 ? false : true;
  }

  onFocus() {
    this.selectInput.nativeElement.focus();
  }

  searchkeyEvent(event) {
    if (event.key === 'Enter') {
      const index = this.itemData.serialstocks.serialnumbers.indexOf(this.searchitem);
      if (index !== -1) {
        this.serialAdd(this.itemData.serialstocks.serialnumbers[index], index);
      }
      setTimeout(() => {
        this.searchitem = '';
      }, 400);
    }
  }
}
